// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  margin: 1rem 0;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.field small {
  color: var(--p-text-muted-color);
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.5rem;
}

.contact-toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

:host ::ng-deep .ng-touched.ng-invalid > .p-inputtext,
:host ::ng-deep input.ng-touched.ng-invalid {
  border-color: var(--p-red-500);
}

@media (max-width: 650px) {
  .fields {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInByb3ZpZGVyLWVkaXQuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFBVSxhQUFBO0VBQWUsZ0RBQUE7RUFBa0QsU0FBQTtFQUFXLGNBQUE7QUFLdEY7O0FBSkE7RUFBUyxhQUFBO0VBQWUsc0JBQUE7RUFBd0IsV0FBQTtBQVVoRDs7QUFUQTtFQUFlLGdDQUFBO0FBYWY7O0FBWkE7RUFBVyxhQUFBO0VBQWUseUJBQUE7RUFBMkIsWUFBQTtFQUFhLGtCQUFBO0FBbUJsRTs7QUFsQkE7RUFBa0IsYUFBQTtFQUFlLG1CQUFBO0VBQXFCLFdBQUE7QUF3QnREOztBQXZCQTs7RUFDOEMsOEJBQUE7QUEyQjlDOztBQTFCQTtFQUE0QjtJQUFVLDBCQUFBO0VBK0JwQztBQUNGIiwiZmlsZSI6InByb3ZpZGVyLWVkaXQuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuZmllbGRzIHsgZGlzcGxheTogZ3JpZDsgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiByZXBlYXQoMiwgbWlubWF4KDAsIDFmcikpOyBnYXA6IDFyZW07IG1hcmdpbjogMXJlbSAwOyB9XG4uZmllbGQgeyBkaXNwbGF5OiBmbGV4OyBmbGV4LWRpcmVjdGlvbjogY29sdW1uOyBnYXA6IC40cmVtOyB9XG4uZmllbGQgc21hbGwgeyBjb2xvcjogdmFyKC0tcC10ZXh0LW11dGVkLWNvbG9yKTsgfVxuLmFjdGlvbnMgeyBkaXNwbGF5OiBmbGV4OyBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kOyBnYXA6IC43NXJlbTsgbWFyZ2luLXRvcDogMS41cmVtOyB9XG4uY29udGFjdC10b2dnbGUgeyBkaXNwbGF5OiBmbGV4OyBhbGlnbi1pdGVtczogY2VudGVyOyBnYXA6IC41cmVtOyB9XG46aG9zdCA6Om5nLWRlZXAgLm5nLXRvdWNoZWQubmctaW52YWxpZCA+IC5wLWlucHV0dGV4dCxcbjpob3N0IDo6bmctZGVlcCBpbnB1dC5uZy10b3VjaGVkLm5nLWludmFsaWQgeyBib3JkZXItY29sb3I6IHZhcigtLXAtcmVkLTUwMCk7IH1cbkBtZWRpYSAobWF4LXdpZHRoOiA2NTBweCkgeyAuZmllbGRzIHsgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiAxZnI7IH0gfVxuIl19 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/settings/provider/provider-edit/provider-edit.component.scss"],"names":[],"mappings":"AAAA;EAAU,aAAA;EAAe,gDAAA;EAAkD,SAAA;EAAW,cAAA;AAKtF;;AAJA;EAAS,aAAA;EAAe,sBAAA;EAAwB,WAAA;AAUhD;;AATA;EAAe,gCAAA;AAaf;;AAZA;EAAW,aAAA;EAAe,yBAAA;EAA2B,YAAA;EAAa,kBAAA;AAmBlE;;AAlBA;EAAkB,aAAA;EAAe,mBAAA;EAAqB,WAAA;AAwBtD;;AAvBA;;EAC8C,8BAAA;AA2B9C;;AA1BA;EAA4B;IAAU,0BAAA;EA+BpC;AACF;AACA,w3CAAw3C","sourcesContent":[".fields { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1rem; margin: 1rem 0; }\n.field { display: flex; flex-direction: column; gap: .4rem; }\n.field small { color: var(--p-text-muted-color); }\n.actions { display: flex; justify-content: flex-end; gap: .75rem; margin-top: 1.5rem; }\n.contact-toggle { display: flex; align-items: center; gap: .5rem; }\n:host ::ng-deep .ng-touched.ng-invalid > .p-inputtext,\n:host ::ng-deep input.ng-touched.ng-invalid { border-color: var(--p-red-500); }\n@media (max-width: 650px) { .fields { grid-template-columns: 1fr; } }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
